export default __webpack_public_path__ + "static/media/icon-close.d13cb5a8.svg";